<div class="row h-100 ">
  <div class="col-md-12 my-auto">
<div class="row justify-content-center">
  <div class="col-md-3">
      <div class="card">
        <div class="content-body">
          <div align ="center">
            <img src="./assets/img/Foodbudgrey.png" alt="" width="60">
          </div>
<h2 class="h4 mt-0 mb-1 centerAlign" >LOG IN</h2>
<p [tcColor]="'#8f8f90'" class="centerAlign" >Login to access your Account</p>
<login-form></login-form>
<p style="text-align: center;" class="mt-3 mb-1"><a [routerLink]="['../', 'forgot']">Forgot password!</a></p>
<p  style="text-align: center;">Don't have an account? <a [routerLink]="['../', 'sign-up']">Sign up!</a></p>
</div>
</div>

</div>
</div>
</div>
</div>